import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getToken } from "./token";

export default function AuthWrapper({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const token = getToken();

  useEffect(() => {
    if (!token) {
      navigate("/authentication/sign-in", {
        replace: true,
        state: { from: location.pathname },
      });
    }
  }, [token, navigate, location.pathname]);

  if (!token) return null;

  return <>{children}</>;
}
